import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MibDTO } from 'src/app/model/configuration/snmp/mib-dto';
import { MibObject } from 'src/app/model/configuration/snmp/mib-object';
import { SnmpObjectConfigurationDTO } from 'src/app/model/configuration/snmp/snmp-object-configuration-dto';

export interface MibObjectSelectorData {
  file: string;
  mib: MibDTO;
  configuredObjects: SnmpObjectConfigurationDTO[];
}

@Component({
  selector: 'app-mib-object-selector-dialog',
  templateUrl: './mib-object-selector-dialog.component.html',
  styleUrls: ['./mib-object-selector-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MibObjectSelectorDialogComponent {
  public selectedObjects: MibObject[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MibObjectSelectorData,
    public dialogRef: MatDialogRef<MibObjectSelectorDialogComponent>
  ) {}

  public isConfigured(object: MibObject): boolean {
    return (
      this.data.configuredObjects.findIndex((o) => o.oid === object.oid) >= 0
    );
  }

  public isSelected(object: MibObject): boolean {
    return this.selectedObjects.findIndex((o) => o.oid == object.oid) >= 0;
  }

  public objectSelectionChanged(object: MibObject) {
    if (this.isSelected(object)) {
      this.selectedObjects = this.selectedObjects.filter(
        (o) => o.oid !== object.oid
      );
    } else {
      this.selectedObjects.push(object);
    }

    console.log('SELECTED', this.selectedObjects);
  }

  public save(): void {
    this.dialogRef.close(this.selectedObjects);
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
